module.exports = __webpack_public_path__ + "static/img/Elaine Li.f6267aa0.png";